/**
 * URL search-param key holding the path a caller was
 * trying to reach before being redirected to `/login`.
 * Set by `clerkAuthMiddleware` and `requirePageAuth`;
 * read by auth screens to bounce the caller back after
 * successful sign-in.
 */
export const REDIRECTED_FROM_PARAM = 'redirectedFrom';
